<script>
    export default {
        name: "UserCompanies",
        props: {
            companies: Array
        },
        mounted() {
            
        },
        methods: {
            
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/user/UserCompanies.vue